import { EmbedEditor } from './core/EmbedEditor';
import { Config, ExportData } from './types';
import { isWindowAvailable } from "./utils/window";

function createEditor(config: Config): EmbedEditor | null {
    if (!isWindowAvailable()) {
        console.error('Window is not available');
        return null;
    }

    if (!config.apiKey) {
        console.error('API Key is required');
        return null;
    }

    return new EmbedEditor(config);
}

export { createEditor };

export type { Config, ExportData };
